import { render, staticRenderFns } from "./settingCompanyCategories.vue?vue&type=template&id=66bb77be&scoped=true&"
import script from "./settingCompanyCategories.vue?vue&type=script&lang=js&"
export * from "./settingCompanyCategories.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyCategories.vue?vue&type=style&index=0&id=66bb77be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb77be",
  null
  
)

export default component.exports